// extracted by mini-css-extract-plugin
export default {"handleButton":"own-action_handleButton__w7pwS"};